import { HirerAccountStatus } from 'src/graphql/generated';

export const getIsAdvertiserEmailUnverified = (status?: HirerAccountStatus) =>
  status === HirerAccountStatus.PENDING_ACTIVATION;
